"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = constraintCartTaxonomyQuantitySum;

var _resolveAndCallStrategy = _interopRequireDefault(require("../resolveAndCallStrategy"));

function constraintCartTaxonomyQuantitySum(ctx, rule, cart, taxonomy, operator, value) {
  return (0, _resolveAndCallStrategy.default)(ctx, 'innerCondition', ['subjectsQuantity', [operator, value]], {
    subjects: (cart.subjects || []).filter(function (s) {
      return !!s.product;
    }).filter(function (s) {
      return (s.product.taxonomies || []).includes(taxonomy);
    })
  });
}